import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewbox="0 0 20 20" fill="none" aria-hidden="true"><path fill="currentColor" d="m9.8 5.5-2-2H5L2.2 6.2h3.1l.6-.5c.5-.5.5-.5.7-.3.2.1.1.3-1.9 2.3l-2.1 2h9.1l1.6-1.5.8.8.8.8h3l-2.2-2.3.3.7.2.5-.8-1-.7-.8 1.6-1.7L18 3.5h-3l-.9.8-.8.8-.9-.8-.8-.8H8.7l1.1 1.1c1 1 1 1 .8.6l-.2-.5L12 6.4s-.5.7-1.2 1.3L9.5 9l-.4-.4c-.3-.3-.4-.3-1.1-.3h-.8l2.6-2.7ZM5 12.2v-2H2.2V15l.8.8c.7.7.8.7 1.3.7h.5v-2l2 2H10l-1.8-1.8C6.5 13 6.5 13 7 13c.3 0 .5-.2 1.7-1.4l1.4-1.4H7l-2 2Z"></path><path fill="currentColor" fill-rule="evenodd" d="m18.2 12.6-2.4-2.4h-5.1l-3.1 3.2 3.1 3.1h3.7l3.8-3.9Zm-7.6.8 1.6-1.6h2.2l.7.8-1 1.2c-1.5 1.4-1.6 1.4-2.7.4l-.8-.8Z" clip-rule="evenodd"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
